<template>
  <div class="min-h-screen w-screen overflow-hidden flex flex-col">
    <div>
      <step-progress step="1" class="py-4 mx-auto bg-dark-blue px-4"></step-progress>
    </div>
    <div
        class="bg-white lg:shadow-lg p-6 lg:py-12 lg:px-16 mx-auto lg:max-w-4xl lg:mt-20 flex flex-1 lg:flex-grow-0 flex-wrap justify-center">

      <div class="hidden lg:block w-2/5 transform -translate-x-32">
        <img src="/images/business-woman@2x.jpg" alt="Start test" class="object-cover shadow-lg">
      </div>

      <div class="lg:w-3/5 lg:-ml-12 flex flex-col lg:flex-row lg:flex-wrap items-center lg:items-start text-center">
        <p class="uppercase text-sm font-bold text-medium-blue w-full text-center">Test :
          {{ $page.props.survey.title[$locale()] }}</p>

        <div>
          <h2 class="mt-8 mb-4 lg:my-10 text-2xl">Vous allez commencer votre test</h2>

          <p class="mb-6 lg:mb-10" v-html="$trans('app.test.start-disclaimer')"></p>

          <div class="flex justify-center">
            <bubble-link :href="route('survey.questions', {survey: $page.props.survey.slug, submission: submission, token: token})">
              {{ $trans('app.start') }}
            </bubble-link>
          </div>
          <div class="text-sm text-dark-blue font-bold mt-2" v-if="!submission && !token">
            <Link :href="route('submission.select_package')">{{ $trans('app.packages.or-choose-formula') }}</Link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue';
import StepProgress from '@/Components/StepProgress.vue';
import BubbleLink from '@/Components/BubbleLink.vue';
import {Link} from '@inertiajs/inertia-vue3';

export default {
  name: "Start",
  props: {
    submission: Object
  },
  components: {
    AppLayout,
    BubbleLink,
    StepProgress,
    Link
  },
  data() {
    return {
      currentQuestion: 0,
    }
  },
  computed: {
    token() {
      return this.route().params.token
    }
  },
  methods: {
    //
  }
}
</script>

<style scoped>

</style>
